import React from "react";
import { motion } from "framer-motion";
import ScrollBar from "../shared/ScrollBar";
import LinkHome from "../shared/LinkHome";

const Contact = () => {
  return (
    <section className="about">
      <ScrollBar />
      <div className="aboutHead">
        <motion.div
          transition={{ duration: 0.2 }}
          animate={{ y: 0, opacity: 1 }}
          initial={{ y: 100, opacity: 0 }}
          className="headline"
        >
          <h2>Let's Make</h2>
          <h2>something great!</h2>
        </motion.div>

        <LinkHome color={"white"} />
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="aboutContent"
      >
        <h2>Contact</h2>
        <p>
          I'm interested in working with companies, agencies, and individuals,
          rather than just working for them. We can work together to solve real
          business-problems in a way that optimizes our respective experience
          and knowledge by bringing my collective development experience to the
          table.
        </p>
        <p>
          As much as possible, I want to avoid subjective squabbles, and prefer
          open-minded collaborators. Let's talk about how we can work together
          if that sounds right.
        </p>
        <p>Feel free to reach out through any platforms below:</p>
        <a
          href="mailto:hello@sadik.works?body=Hi Sadik,"
          target="_blank"
          rel="noopener"
        >
          hello@sadik.works
        </a>
        <br />
        <a href="https://github.com/msadikjowel" target="_blank" rel="noopener">
          GitHub
        </a>
        <br />
        <a
          href="https://www.linkedin.com/in/msadikjowel/"
          target="_blank"
          rel="noopener"
        >
          LinkedIn
        </a>
        <br />
        <a
          href="https://twitter.com/msadikjowel"
          target="_blank"
          rel="noopener"
        >
          Twitter
        </a>
        <br />
        <a
          href="https://www.instagram.com/msadikjowel/"
          target="_blank"
          rel="noopener"
        >
          Instagram
        </a>
        <br />
        <a
          href="https://www.facebook.com/msadikjowel"
          target="_blank"
          rel="noopener"
        >
          Facebook
        </a>
      </motion.div>
    </section>
  );
};

export default Contact;
